import React, { Component } from 'react';
import Panel from './shared/Panel';
import PeriodSelector from './shared/PeriodSelector';
import DappContractUsersChart from './containers/DappContractUsersChart';
import Info from './shared/Info';

export default class DappContractUsersChartPanel extends Component {
	state = {
		period: '1W'
	};

	onPeriodSelect = (e, { value }) => {
		this.setState({ period: value });
	};

	render() {
		const { period } = this.state;
		return (
			<Panel
				title={
					<React.Fragment>
						USERS <Info id="contractUsers" />
					</React.Fragment>
				}
				titleClass="light"
				description=""
				toolbar={<PeriodSelector value={period} onSelect={this.onPeriodSelect} />}
			>
				<DappContractUsersChart period={period} />
			</Panel>
		);
	}
}